export const AchievementInitialValues = (showData) => ({
  amount: showData?.data?.amount || "",
  icon: null,
});
